import { render, staticRenderFns } from "./PoHomeworkRegist.vue?vue&type=template&id=4d50375c&scoped=true"
import script from "./PoHomeworkRegist.vue?vue&type=script&lang=js"
export * from "./PoHomeworkRegist.vue?vue&type=script&lang=js"
import style0 from "./PoHomeworkRegist.vue?vue&type=style&index=0&id=4d50375c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d50375c",
  null
  
)

export default component.exports